import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9f5fc994&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5fc994",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2026/Temperature/TempAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f5fc994')) {
      api.createRecord('9f5fc994', component.options)
    } else {
      api.reload('9f5fc994', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9f5fc994&scoped=true&", function () {
      api.rerender('9f5fc994', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rw/tempAdd/index.vue"
export default component.exports